module.exports = {"210281001":"新华","210281002":"文兰","210281003":"岭东","210281004":"共济","210281005":"铁东","210281006":"祝华","210281007":"岗店","210281008":"太阳街道","210281009":"长兴岛","210281010":"九龙","210281011":"交流岛街道","210281101":"复州城镇","210281103":"松树镇","210281105":"得利寺镇","210281106":"万家岭镇","210281107":"许屯镇","210281108":"永宁镇","210281109":"谢屯镇","210281112":"老虎屯镇","210281113":"红沿河镇","210281115":"李官镇","210281116":"仙浴湾镇","210281117":"元台镇","210281118":"瓦窝镇","210281201":"赵屯乡","210281203":"土城乡","210281204":"阎店乡","210281205":"西杨乡","210281206":"驼山乡","210281208":"三台满族乡","210281210":"泡崖乡","210281212":"杨家满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210281.json
// module id = 522
// module chunks = 0